import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { toastManager } from "../../Utils/toastManager";

// On-brand styling per toast type. Accent bar + icon colour communicate intent.
const TYPE_STYLES = {
  success: {
    icon: "lucide:check-circle-2",
    accent: "bg-emerald-500",
    iconColor: "text-emerald-500",
  },
  error: {
    icon: "lucide:alert-circle",
    accent: "bg-red-500",
    iconColor: "text-red-500",
  },
  warning: {
    icon: "lucide:alert-triangle",
    accent: "bg-warning",
    iconColor: "text-warning",
  },
  info: {
    icon: "lucide:info",
    accent: "bg-brand-blue",
    iconColor: "text-brand-blue",
  },
};

const ToastCard = ({ toast }) => {
  const style = TYPE_STYLES[toast.type] || TYPE_STYLES.info;

  return (
    <div
      role="status"
      aria-live="polite"
      className="toast-enter pointer-events-auto relative flex w-full items-start gap-3 overflow-hidden rounded-xl border border-slate-200 bg-white py-3 pl-4 pr-3 shadow-lg"
    >
      <span
        className={`absolute inset-y-0 left-0 w-1.5 ${style.accent}`}
        aria-hidden="true"
      />
      <Icon
        icon={style.icon}
        className={`mt-0.5 h-5 w-5 shrink-0 ${style.iconColor}`}
      />
      <div className="min-w-0 flex-1">
        {toast.title ? (
          <p className="text-sm font-semibold text-primary-900">{toast.title}</p>
        ) : null}
        <p
          className={`break-words text-sm ${
            toast.title ? "text-tertiary-600" : "font-medium text-primary-900"
          }`}
        >
          {toast.message}
        </p>
      </div>
      <button
        type="button"
        aria-label="Dismiss notification"
        onClick={() => toastManager.dismiss(toast.id)}
        className="-mr-1 shrink-0 rounded-md p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
      >
        <Icon icon="lucide:x" className="h-4 w-4" />
      </button>
    </div>
  );
};

// Root-mounted viewport. Subscribes to the toastManager singleton and renders
// the active toast stack in the top-right corner.
const Toaster = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => toastManager.subscribe(setToasts), []);

  if (!toasts.length) return null;

  return (
    <div className="pointer-events-none fixed top-4 left-1/2 z-[10000] flex w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 flex-col gap-3">
      {toasts.map((toast) => (
        <ToastCard key={toast.id} toast={toast} />
      ))}
    </div>
  );
};

export default Toaster;
